import { useEffect, useState } from "react";
import useAlertBar from "@/hooks/useAlertBar";
import { getUser } from "@/services/userService";
import { dashboardUrl, newDashboardUrl } from "@/utils/constants";
import {
  accessTokenSessionExpiryKey,
  accessTokenSessionKey,
  refreshExpiryPartialKey,
  refreshTokenKey,
} from "@/utils/token-manager";
import { Button, Card, CardBody } from "reactstrap";

export default function DashboardSelection() {
  const { openAlertBar } = useAlertBar();

  const [isBetaUser, setIsBetaUser] = useState(false);
  const [loading, setLoading] = useState(true);

  // ✅ Call only once
  useEffect(() => {
    const fetchUser = async () => {
      const accessToken = localStorage.getItem(accessTokenSessionKey);

      if (!accessToken) {
        setLoading(false);
        return;
      }

      try {
        const user = await getUser(accessToken);
        setIsBetaUser(user.data.is_beta_user);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const getTokens = () => {
    const accessToken = localStorage.getItem(accessTokenSessionKey);
    const expiryAt = localStorage.getItem(accessTokenSessionExpiryKey);
    const refreshToken = localStorage.getItem(refreshTokenKey);
    const refreshExpiryAt = localStorage.getItem(
      refreshTokenKey + refreshExpiryPartialKey,
    );

    return { accessToken, expiryAt, refreshToken, refreshExpiryAt };
  };

  const goToOldDashboard = () => {
    const { accessToken, expiryAt, refreshToken, refreshExpiryAt } =
      getTokens();

    const url = `${dashboardUrl}/login-success?accessToken=${accessToken}&expireAt=${expiryAt}&refreshToken=${refreshToken}&refreshExpireAt=${refreshExpiryAt}`;

    window.location.href = url;
  };

  const goToNewDashboard = () => {
    if (!isBetaUser) {
      openAlertBar("You are not allowed to access the new dashboard.", false);
      return;
    }

    const { accessToken, expiryAt, refreshToken, refreshExpiryAt } =
      getTokens();

    const url = `${newDashboardUrl}/login-success?accessToken=${accessToken}&expireAt=${expiryAt}&refreshToken=${refreshToken}&refreshExpireAt=${refreshExpiryAt}`;

    window.location.href = url;
  };

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <Card style={{ width: "400px" }}>
        <CardBody className="text-center p-5">
          <h3 className="mb-4 text-secondary">Select Dashboard</h3>

          <Button
            color="secondary"
            className="w-100 mb-3"
            onClick={goToOldDashboard}
          >
            Go to Old Dashboard
          </Button>

          <Button
            color="primary"
            className="w-100"
            onClick={goToNewDashboard}
            disabled={!isBetaUser || loading}
          >
            Go to New Dashboard
          </Button>
        </CardBody>
      </Card>
    </div>
  );
}
